import { useRouter } from '@tanstack/react-router';
import { Page } from '@uturn/portal/components';
import { InfoRouteCardSkeleton } from '@uturn/portal/components/info-route-card';
import { Suspense } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { LanesList } from '../components/lanes-list';

export function LanesOverview() {
	const { t } = useTranslation();
	const router = useRouter();

	return (
		<>
			<Helmet title={t('pages.lanes.overview.title', 'Lanes').toString()} />
			<Page
				title={t('pages.lanes.overview.title', 'Lanes').toString()}
				primaryAction={{
					label: t('pages.lanes.overview.create', 'Create lane'),
					onClick: () => router.navigate({ to: '/lanes/create' }),
				}}
				className="m-auto grid gap-2 md:max-w-[850px]"
			>
				<div className="grid gap-3">
					<Suspense
						fallback={
							<>
								<InfoRouteCardSkeleton />
								<InfoRouteCardSkeleton />
								<InfoRouteCardSkeleton />
							</>
						}
					>
						<LanesList />
					</Suspense>
				</div>
			</Page>
		</>
	);
}
